import type { PublicApiKey } from '#packages/apilib';
import type { createDuplicatePageCodeConditionApi } from './createDuplicatePageCodeConditionApi';

export const DuplicatePageCodeConditionApiKey: PublicApiKey<
  typeof createDuplicatePageCodeConditionApi
> = {
  name: 'DuplicatePageCodeConditionApi',
  public: true,
};
